var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownwardArrowLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.500432 0.898269C0.745044 0.613455 1.16643 0.5878 1.44161 0.840968L6.9987 5.95337L12.5558 0.840968C12.831 0.5878 13.2524 0.613455 13.497 0.898269C13.7416 1.18308 13.7168 1.6192 13.4416 1.87237L7.88452 6.98478C7.37934 7.44953 6.61807 7.44953 6.11289 6.98478L0.555796 1.87237C0.280607 1.6192 0.25582 1.18308 0.500432 0.898269Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownwardArrowLight);
export default __webpack_public_path__ + "static/media/downward-arrow-light.eb83c4141a174c6fd58b7c758357b870.svg";
export { ForwardRef as ReactComponent };